import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Trust wrapper for HTML authored by internal editors — never user input.
 *
 * Callers (all verified as internal-only sources):
 *  - Storyblok-sourced knowledge pages (`knowledge-*` components): content is
 *    authored in the Panorama editorial CMS by named Roche staff; Storyblok
 *    itself gates access.
 *  - `focus-knowledge-form`: rendered from the rich-text-editor output written
 *    by Focus offering owners (Ping-authenticated internal users).
 *
 * If a NEW caller ever passes untrusted HTML (public form input, URL params,
 * third-party APIs), it MUST sanitise itself and this pipe must not be used —
 * or this trust doc must be revisited.
 */
@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (!value) {
      return '';
    }

    // Unescape quotes if the rich text string arrives with literal \"
    const cleanHtml = value.replace(/\\"/g, '"');

    // NOSONAR: S6268 — trust chain reviewed in the class-level doc above.
    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml); // NOSONAR
  }
}
